import styled from "styled-components";

/**
 * Componente ContainerDetailsFlights
 *
 * Container principal dos detalhes de resultados dos voos.
 */
export const ContainerDetailsFlights = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

/**
 * Componente StyledDetailsHeader
 *
 * Div para o cabeçalho dos detalhes de resultados dos voos.
 */
export const StyledDetailsHeader = styled.div`
  display: flex;
  width: 100%;
  /* background-color: darkgray; */
  justify-content: center;
  align-items: center;
  /* flex-direction: column; */
`;

export const SyledRouter = styled.div`
  display: flex;
  /* width: 100%; */
  /* background-color: bisque; */
`;

/**
 * Componente StyledDetailsFlight
 *
 * Div para o detalhe do voo.
 */
export const StyledDetailsFlight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  & > svg {
    margin-top: ${({ theme }) => theme.spacing(-0.3)};
    stroke-width: 2;
  }
`;

/**
 * Componente PassengersContent
 *
 * Div para o conteúdo de passageiros.
 */
export const PassengersContent = styled.div`
  /* background-color: violet; */
  margin-left: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(0)};
  display: flex;
  /* position: absolute;
  align-self: flex-end;
  right: 10px; */

  & > span {
    gap: ${({ theme }) => theme.spacing(0.5)};
    align-items: center;
    display: flex;
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

/**
 * Componente ContainerDatesFlight
 *
 * Div para as datas do voo.
 */
export const ContainerDatesFlight = styled.div<{ isColumn?: boolean }>`
  gap: ${({ theme, isColumn }) => theme.spacing(isColumn ? 0.5 : 2)};
  display: flex;
  margin-top: 5px;
  width: 100%;
  width: ${({ isColumn }) => (isColumn ? "auto" : "100%")};
  justify-content: center;
  align-items: ${({ isColumn }) => (isColumn ? "center" : "center")};
  flex-direction: ${({ isColumn }) => (isColumn ? "column" : "row")};
`;

/**
 * Componente StyledDatesFlight
 *
 * Div para as datas do voo.
 */
export const StyledDatesFlight = styled.div`
  gap: ${({ theme }) => theme.spacing(1)};
  display: flex;
`;

export const PassengerIcon = styled.div`
  width: 7px;
  /* height: 25px; */
  display: inline-flex;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const PassengerLabelCount = styled.div`
  display: flex;
  margin-right: 5px;
`;

export const EditDivIcon = styled.div`
  display: flex;
  margin-bottom: 2px;
`;
